import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

import { makeStyles, Badge, Popover } from '@material-ui/core'

import CommentIcon from '@material-ui/icons/Comment'
import Send from '@material-ui/icons/Send'
import PriorityHigh from '@material-ui/icons/PriorityHigh'

import LongText from '../element/LongText'
import BootstrapAlert from '../element/BootstrapAlert'
import ErrorBoundary from '../ErrorBoundary'
import Transit from '../Transit'

import { Globalize } from '@mescius/wijmo'

const useStyles = makeStyles((theme) => ({
  commentWindow: {
    width: '400px',
    maxHeight: '500px',
    padding: '1rem'
  },
  commentList: {
    height: '250px',
    overflowY: 'auto',
    marginTop: '20px',
    overflowWrap: 'break-word'
  }
}))

export default function WfComment (props) {
  const classes = useStyles()
  const { contractId } = props

  const [anchorEl, setAnchorEl] = useState(null)
  const [comments, setComments] = useState({ licensee_comments: [], contract_comments: [] })
  const [licenseeMode, setLicenseeMode] = useState(true)
  const [selectedId, setSelectedId] = useState(null)
  const [inTransit, setInTransit] = useState(false)
  const [inError, setInError] = useState(false)
  const csrfRef = useRef($('meta[name="csrf-token"]'))

  const loadComments = () => {
    setInTransit(true)

    $.ajax({
      url: props.getUrl,
      type: 'GET'
    }).done((data) => {
      setComments(data)
    }).fail((jqXHR, textStatus, errorThrown) => {
      console.error(errorThrown)
    }).always(() => {
      setInTransit(false)
    })
  }

  useEffect(() => {
    loadComments()
  }, [])

  const resetCsrfToken = (token) => {
    csrfRef.current.attr('content', token)
    $('input[name="_token"]').val(token)
  }

  const onStoreFormSubmit = (e) => {
    e.preventDefault()

    const form = e.target
    $.ajax({
      url: form.action,
      type: 'POST',
      data: $(form).serializeArray()
    }).done((data) => {
      loadComments()
      $(form).find('textarea[name="comment"]').val('')
      resetCsrfToken(data['csrf-token'])
    }).fail((jqXHR, textStatus, errorThrown) => {
      if (jqXHR.status === 419) {
        setInError(true)
      } else {
        console.error(errorThrown)
      }
    })
  }

  const onCommentSelect = (id) => (e) => {
    e.preventDefault()
    setSelectedId(selectedId === id ? null : id)
  }

  const onPinButtonClick = (e) => {
    e.preventDefault()
    $.ajax({
      url: licenseeMode ? props.pinLicenseeUrl : props.pinContractUrl,
      type: 'POST',
      data: {
        _token: csrfRef.current.attr('content'),
        id: selectedId,
        contract_id: contractId
      }
    }).done((data) => {
      loadComments()
      setSelectedId(null)
      resetCsrfToken(data['csrf-token'])
    }).fail((jqXHR, textStatus, errorThrown) => {
      if (jqXHR.status === 419) {
        setInError(true)
      } else {
        console.error(errorThrown)
      }
    })
  }

  const onDeleteButtonClick = (e) => {
    e.preventDefault()
    if (confirm('削除したメモは復元できません。本当に削除しますか？')) {
      $.ajax({
        url: licenseeMode ? props.deleteLicenseeUrl : props.deleteContractUrl,
        type: 'POST',
        data: {
          _token: csrfRef.current.attr('content'),
          id: selectedId,
          contract_id: contractId
        }
      }).done((data) => {
        loadComments()
        setSelectedId(null)
        resetCsrfToken(data['csrf-token'])
      }).fail((jqXHR, textStatus, errorThrown) => {
        if (jqXHR.status === 419) {
          setInError(true)
        } else {
          console.error(errorThrown)
        }
      })
    }
  }

  const onTabClick = (isLicenseeTab) => (e) => {
    e.preventDefault()
    setLicenseeMode(isLicenseeTab)
    setSelectedId(null)
  }

  const commentCount = comments.licensee_comments.length + comments.contract_comments.length
  return (
    <>
      <button type='button' className="btn btn-lg btn-info fixed-lower-right shadow"
        title={`${commentCount}件のメモがあります。`}
        onClick={(e) => setAnchorEl(e.currentTarget)}>
        <Badge overlap='rectangular' badgeContent={commentCount} color="primary">
          <CommentIcon></CommentIcon>
        </Badge>
      </button>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
      >
        <div className={classes.commentWindow}>
          {inError && (
            <div className="alert alert-danger">
              エラー：同じリクエストが連続で行われた可能性があります。ページを更新してください。
            </div>
          )}
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <a href="#" className={`nav-link ${licenseeMode ? 'active' : ''}`} onClick={onTabClick(true)}>
                ライセンシー<span className="badge badge-primary mx-2 align-middle">{comments.licensee_comments.length}</span>
              </a>
            </li>
            <li className="nav-item">
              <a href="#" className={`nav-link ${licenseeMode ? '' : 'active'}`} onClick={onTabClick(false)}>
                契約<span className="badge badge-primary mx-2 align-middle">{comments.contract_comments.length}</span>
              </a>
            </li>
          </ul>
          <form action={licenseeMode ? props.storeLicenseeUrl : props.storeContractUrl} method="post" onSubmit={onStoreFormSubmit}>
            <input type="text" className="d-none" name="_token" value={csrfRef.current.attr('content')} readOnly />
            <input type="text" className="d-none" name="contract_id" value={contractId} readOnly />
            <textarea name="comment" rows="3" className='form-control' maxLength="340" placeholder='メモ内容（最大340字）'></textarea>
            <div className="d-flex mt-1">
              <div className="flex-fill">
                <BootstrapAlert class="info">
                  <div>{licenseeMode ? 'このメモは同一ライセンシー・グループの契約で表示されます。' : 'このメモはこの契約に関する申請で表示されます。'}</div>
                </BootstrapAlert>
              </div>
              <button type="submit" className="btn bg-theme-primary mb-3"><Send></Send></button>
            </div>
          </form>
          <div className={classes.commentList}>
            {Transit({
              inTransit: inTransit,
              element: (
                <div className="list-group">
                  {(licenseeMode ? comments.licensee_comments : comments.contract_comments).map((comment) => (
                    <div key={comment.id}>
                      <button className={`list-group-item list-group-item-action ${comment.is_pinned ? 'list-group-item-danger' : ''}`} onClick={onCommentSelect(comment.id)}>
                        <small><b>{comment.sp_user.name}</b> {Globalize.format(new Date(comment.created_at), 'F')}</small>
                        <div className={`float-right text-danger ${comment.is_pinned ? '' : 'd-none'}`}><PriorityHigh></PriorityHigh></div>
                        <LongText text={comment.comment}></LongText>
                      </button>
                      {selectedId === comment.id && (
                        <div className="d-flex mb-3">
                          <button type="button" className="flex-fill btn btn-outline-primary rounded-0" onClick={onPinButtonClick}>
                            {comment.is_pinned ? 'ピン止めを外す' : 'ピン止めする'}
                          </button>
                          {comment.is_deletable && (
                            <button type="button" className="flex-fill btn btn-danger rounded-0" onClick={onDeleteButtonClick}>
                              削除
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )
            })}
          </div>
        </div>
      </Popover>
    </>
  )
}

WfComment.propTypes = {
  contractId: PropTypes.number,
  getUrl: PropTypes.string,
  storeLicenseeUrl: PropTypes.string,
  storeContractUrl: PropTypes.string,
  deleteLicenseeUrl: PropTypes.string,
  deleteContractUrl: PropTypes.string,
  pinLicenseeUrl: PropTypes.string,
  pinContractUrl: PropTypes.string
}

$('#wf-comment').each((i, elem) => {
  const props = $(elem).data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  ReactDOM.render(
    <ErrorBoundary>
      <WfComment {...props}/>
    </ErrorBoundary>,
    elem
  )

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    $(elem).removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
